import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  value: {},
}

export const UserServicesSlice = createSlice({
  name: 'UserServices',
  initialState,
  reducers: {
    update: (state,action) => {
       state.value = action.payload;
    }
  }
})

export const { update } = UserServicesSlice.actions
export default UserServicesSlice.reducer
